import { useContext, useMemo } from 'react';

import { AnalyticsContext } from './analytics-context';
import type { AnalyticsEvent, GroupIdentity, UserIdentity } from './types';

const useAnalytics = () => {
  const { adapter } = useContext(AnalyticsContext);

  return useMemo(
    () => ({
      identify: (identity: UserIdentity) => adapter?.identify(identity),
      reset: () => adapter?.reset(),
      setGroup: (group: GroupIdentity) => adapter?.setGroup(group),
      trackEvent: (event: AnalyticsEvent) => adapter?.trackEvent(event),
      trackPageView: (path?: string) => adapter?.trackPageView(path),
    }),
    [adapter]
  );
};

export { useAnalytics };
